/**
 * @Author:
 * @Description:
 * @DateTime: Created in 17:28 2020/10/16
 * 数据审核列表页面
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import { createBEM, createNamespace } from 'src/util/bem';
import './handleAudit.less';
import AgGridVueCustomTsx, { ColDefCustom } from 'src/components/agGridCustom/agGridVueCustomTsx';
import { GridOptions } from 'ag-grid-community';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import DataAuditApi, { DataAuditDOI } from './api/dataAuditApi';
import CheckboxNumberRender from 'src/components/agGridComponent/checkboxNumberRender';
import CheckboxHead from 'src/components/agGridComponent/checkboxHead';
import { PublicApiI } from 'src/util/publicApi';
import EnumAuditStatus from 'src/enums/enumAuditStatus';
import Button from 'src/types/iview/Button';
import RouteUtils from 'src/util/routeUtils';
import { Toast } from 'src/util/toast';
import alertAuditRuleViewModal from './auditRuleViewModal';
//
import alertAuditDataModal from './auditDataModal';
import { parse } from 'querystring';
let bem = createBEM('handle-audit');

export interface HandleAuditPropsI {
    value: string | number;
}
export enum AuditStatus {
    UnAudit = 0,
    Audit = 1,
}

@Component({ name: 'data-manage-data-audit-handle' })
export default class HandleAudit extends Vue.Component<HandleAuditPropsI> {
    @Prop({
        type: [String, Number],
    })
    value!: string | number;

    auditLoading: boolean = false;
    serialCheckBoxShows: boolean = true;
    // 附件相关的表格
    gridOptions: GridOptions = {};
    //TODO 临时变量复制
    temporaryList: any = [];

    columnDefs: ColDefCustom[] = [];
    columnDefTime: ColDefCustom[] = [
        {
            headerName: '时间',
            field: 'timestamp',
            minWidth: 140,
            cellRenderer(params) {
                return params.data.footer ? params.data.timestamp : DateTimeUtil.formateDate(params.data.timestamp * 1000);
            },
        },
    ];
    // 无效标识数组
    dataSource: any = [];
    rowData: any[] = [];
    components: ReadonlyArray<PublicApiI.DivisorI> = [];
    // 存储选择整行或者整列的数据
    selectAllData: any = [];
    datas:any=[];
    audits: number = 0;
    auditStatus!: number;

    startOfDaySec!: number;
    endOfDaySec!: number;

    get agRow() {
        return [...this.rowData];
    }
    // 处理站点名称
    formatSiteName(val: string) {
        return val.slice(0, val.indexOf('('));
    }
    // TODO 选择某列
    onCheck(v: boolean, params) {
        let colDef = params.column.colDef;
        if (v) {
            this.temporaryList.push({
                component_name: this.formatSiteName(colDef.headerName!),
                component: colDef.field,
            });
        } else {
            this.temporaryList = this.temporaryList.filter(i => i.component !== colDef.field);
        }
        if (this.temporaryList.length) {
            this.serialCheckBoxShows = false;
            let timestampList = this.rowData.map(i => {
                return {
                    id: i.id,
                    timestamp: i.timestamp,
                };
            });
            this.selectAllData = [
                {
                    timestamps: timestampList,
                    components: this.temporaryList,
                },
            ];
        } else {
            this.serialCheckBoxShows = true;
            this.selectAllData = [];
        }
        // 选择列时候
        let field: string = params.column.colDef.field; // headerName
        let header = this.columnDefs.find(i => i.field === field)!;
        // TODO 之前的代码
        this.rowData.forEach(i => {
            i[field].selected = v;
        });
        header.headerComponentFrameworkOpt.indeterminate = false;
    }
    // TODO 选择某行
    getSelectionData(data) {
        let datas = data.api.getSelectedRows();
        if (!datas.length) {
            this.selectAllData = [];
            // 无选择数据，则开启列
            this.columnDefs.forEach(i => {
                if (i.headerComponentFrameworkOpt) {
                    i.headerComponentFrameworkOpt.indeterminate = false;
                    i.headerComponentFrameworkOpt.disabled = false;
                }
            });
            return;
        }
        // 选中行，则禁用列
        this.columnDefs.forEach(i => {
            if (i.headerComponentFrameworkOpt) {
                i.headerComponentFrameworkOpt.indeterminate = true;
                i.headerComponentFrameworkOpt.disabled = true;
            }
        });
        let component = this.columnDefs.filter(item => item.field != 'timestamp');
        let timestampList = datas.map(i => {
            return {
                id: i.id,
                timestamp: i.timestamp,
            };
        });
        let componentList = component.map(i => {
            return {
                component_name: this.formatSiteName(i.headerName!),
                component: i.field,
            };
        });

        // 创建一个Set来存储保留的component
        let componentsToKeep = new Set();
        // 遍历datas，如果value不为NaN，则将component添加到Set中
        datas.forEach(data => {
            Object.keys(data).forEach(key => {
                if (key !== "id" && key !== "timestamp" && key !== "isRealTimeData" && key !== "iden") {
                    let value = data[key].value;
                    if (!isNaN(value)) {
                        componentsToKeep.add(key);
                    }
                }
            });
        });

        // 根据Set中的component保留componentList中的项
        componentList = componentList.filter(component => componentsToKeep.has(component.component));

        console.log("componentList",componentList)

        this.selectAllData = [
            {
                timestamps: timestampList,
                components: componentList,
            },
        ];
        this.datas=datas;
    }
    // TODO 点击某个单元格
    async getCellClicked(event) {
        // 根据审核时间和审核因子查询审核详情 点击弹框回显
        let { data, colDef, value } = event;
        // if(value.value == "") return;
        if (this.audits != 1 || (value && !value.value && value.value != 0)) return;
        if (data.footer || ['序号', '时间'].includes(colDef.headerName)) return;
        let params = {
            device_name: this.$route.query.name,
            mn: this.$route.query.mn,
            value: value.value,
            check_info: [
                {
                    id: data.id,
                    timestamp: data.timestamp,
                    component: colDef.field,
                    component_name: this.formatSiteName(colDef.headerName),
                },
            ],
        };
        let res = await alertAuditDataModal(params, 'one', this.dataSource);
        if (res) this.getAuditLists();
    }
    onCellCheck(v: boolean, params) {
        let field: string = params.column.colDef.field;
        let checkCount = this.rowData.filter(i => i[field].selected && i.isRealTimeData).length;
        let header = this.columnDefs.find(i => i.field === field)!;
        if (checkCount === 0) {
            header.headerComponentFrameworkOpt.indeterminate = false;
            header.headerComponentFrameworkOpt.selected = false;
        } else if (checkCount < this.rowData.length) {
            header.headerComponentFrameworkOpt.indeterminate = true;
            header.headerComponentFrameworkOpt.selected = false;
        } else {
            header.headerComponentFrameworkOpt.indeterminate = true;
            header.headerComponentFrameworkOpt.selected = true;
        }
    }
    // TODO 处理获取到的表格数据
    setRowData(data: DataAuditDOI.DataDetailI[]) {
        let map: any = {};
        let components: PublicApiI.DivisorI[] = [];
        data.forEach(i => {
            // 所有因子
            components.push({ name: i.name, key: i.key, unit: i.unit });
            i.data.forEach(j => {
                map[j.timestamp] = map[j.timestamp] || { isRealTimeData: true, id: j.id };
                map[j.timestamp].timestamp = j.timestamp;
                // TODO 新增序号切换表示
                map[j.timestamp].iden = 'switch';
                // TODO 新增audits 审核参数用于列表改变颜色
                map[j.timestamp][i.key] = {
                    flag: j[`${i.key}-Flag`],
                    value: j[`${i.key}-Rtd`] == "--" ? "" : j[`${i.key}-Rtd`],
                    audits: j[`${i.key}-Audit`],
                    ckecked: j[`${i.key}-Checks`],
                    nullData: j[`${i.key}-NullData`],
                    selected: false,
                };
            });
        });
        this.components = Object.freeze(components);
        let rows: any = Object.values(map);
        rows.sort((a, b) => a.timestamp - b.timestamp);
        this.rowData = rows;
    }
    async setFooter() {
        let ag = this.$refs.ag as AgGridVueCustomTsx;
        (await ag.getApi()).setPinnedBottomRowData([]);
    }
    // * API:数据审核根据站点返回数据
    async getAuditLists() {
        let lists: any = [];
        let { code, data } = await DataAuditApi.searchDataDetail({
            mn: this.$route.query.mn,
            start_time: DateTimeUtil.getSecondFromIviewDate(new Date(+this.$route.query.date), 'start')!,
            end_time: DateTimeUtil.getSecondFromIviewDate(new Date(+this.$route.query.date), 'end')!,
        });
        if (code === 0) {
            // 处理获取的审核数据
            this.setRowData(data);
            // 获取审核列表的数据data
            lists = [
                ...this.columnDefTime,
                ...data.map(i => {
                    return {
                        headerName: `${i.name}(${i.unit})`,
                        field: i.key,
                        minWidth: 120,
                        cellRendererFramework: CheckboxNumberRender,
                        cellRendererFrameworkOpt: {
                            onCheck: this.onCellCheck.bind(this),
                            editable: params => {
                                // 如果params.data[i.key].ckecked === AuditStatus.UnAudit 则为未审计  如果为未审计则开启可编辑按钮
                                return params.data[i.key] ? params.data[i.key].ckecked === AuditStatus.UnAudit : false;
                            },
                            precision: 2,
                        },
                        headerComponentFramework: CheckboxHead,
                        headerComponentFrameworkOpt: {
                            // showSelect: i.data.some(j => j[`${i.key}-Checks`] === AuditStatus.UnAudit),
                            showSelect: i.data.some(j => j[`${i.key}-Rtd`] !== "--"),
                            onCheck: this.onCheck.bind(this),
                            selected: false,
                            indeterminate: false,
                            disabled: false,
                        },
                    };
                }),
            ];
            this.selectAllData = [];
            this.columnDefs = lists;
        }
    }

    // TODO 刷新审核状态
    async refreshAuditStatus() {
        const date = new Date(+this.$route.query.date);
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        const startOfDay = new Date(year, month, day, 0, 0, 0); // 设置为当天的开始时间
        this.startOfDaySec = Math.floor(startOfDay.getTime() / 1000); // 转换为秒级

        const endOfDay = new Date(year, month, day + 1);
        endOfDay.setMilliseconds(endOfDay.getMilliseconds() - 1);
        this.endOfDaySec = Math.floor(endOfDay.getTime() / 1000); // 转换为秒级
        console.log('startOfDaySec', this.startOfDaySec, 'endOfDaySec', this.endOfDaySec);
        let { code, data } = await DataAuditApi.searchAudit({
            mn: this.$route.query.mn,
            start_time: this.startOfDaySec,
            end_time: this.endOfDaySec,
        });
        if (code === 0) {
            data.forEach(i => {
                this.auditStatus = parseInt(i.check_status, 10);
                this.$forceUpdate(); // 强制组件重新渲染
            });
        }
    }
    // * API:查询用户是否拥有审核权限
    async getAuditActivitys() {
        let { code, data } = await DataAuditApi.getAuditActivity();
        if (code == 0) {
            // audit 1有权限 2无权限
            this.audits = data.audit;
        }
    }
    // * API:获取无效标识集列表
    async getList() {
        let { data } = await DataAuditApi.InvalidIdentifiersList();
        if (data) {
            let list = data.map(i => {
                return {
                    id: i.id,
                    flag: i.code,
                    name: i.name,
                    priority_level: i.priority_level,
                };
            });
            this.dataSource = [...list];
        }
    }
    async mounted() {
        this.auditStatus = parseInt(this.$route.query.status);
        await this.getAuditActivitys();
        await this.getAuditLists();
        await this.getList();
    }
    // * API：批量审核
    async audit() {
        if (!this.selectAllData.length) {
            return Toast.error('未勾选数据');
        }
        let params = {
            device_name: this.$route.query.name,
            mn: this.$route.query.mn,
            check_info: this.selectAllData,
            datas: this.datas,
            value: '',
        };
        let res = await alertAuditDataModal(params, 'all', this.dataSource);
        if (res) {
            // 清空数据 初始化状态
            this.temporaryList = [];
            this.columnDefs = [...this.columnDefTime];
            this.serialCheckBoxShows = true;
            await this.getAuditLists();
            await this.refreshAuditStatus();
        }
    }
    seeRule() {
        alertAuditRuleViewModal();
    }
    render(h) {
        return (
            <div class={bem()}>
                <div class={bem('title')}>
                    <span class={createNamespace('mr20')}>站点名称：{this.$route.query.name}</span>
                    <span class={createNamespace('mr20')}>日期：{DateTimeUtil.formateDate(+this.$route.query.date, 'YYYY-MM-DD')}</span>
                    <span class={createNamespace('mr20')}>
                        状态：<span class={bem('status')}>{EnumAuditStatus.findId(this.auditStatus).getName()}</span>
                    </span>
                    <Button v-show={this.audits == 1} type="primary" class={createNamespace('mr20')} on-click={this.seeRule.bind(this)}>
                        无效标识集
                    </Button>
                    <Button v-show={this.audits == 1} type="primary" class={createNamespace('mr20')} onClick={this.audit.bind(this)}>
                        批量审核
                    </Button>
                    <div class={bem('back')} onClick={() => RouteUtils.goBack()}>
                        返回
                    </div>
                </div>
                <div class={bem('table')}>
                    <AgGridVueCustomTsx
                        ref="ag"
                        gridOptions={this.gridOptions}
                        columnDefs={this.columnDefs}
                        rowData={this.agRow}
                        enableServerSideSorting={false}
                        serialCheckBoxShow={this.serialCheckBoxShows}
                        pageShow={false}
                        selectionChanged={data => this.getSelectionData(data)}
                        cellClicked={event => this.getCellClicked(event)}
                    />
                </div>
            </div>
        );
    }
}
